import React, { useCallback, useState } from 'react';

import Message from 'components/Message';
import Tooltip from 'components/Tooltip';

import {
  NotificationType,
  useSetNotificationShownMutation,
  useUserNotificationsQuery,
} from 'graphql/generated/graphql';

import { useAuth } from 'hooks/useAuth';
import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

interface IProps {
  anchorEl: React.RefObject<HTMLDivElement>;
}

const FirstTimeTooltip = ({ anchorEl }: IProps) => {
  const [popperOpen, setPopperOpen] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();

  useUserNotificationsQuery({
    ...useGraphaelDefaults(),
    onCompleted: (data) => {
      const shouldShowPopper = !data.userNotifications.find(
        (notification) =>
          notification.notificationType ===
          NotificationType.StoryDetailsActionsMenuTooltip,
      );

      setPopperOpen(shouldShowPopper);
    },
    skip: !isAuthenticated,
  });

  const [setNotificationShown] = useSetNotificationShownMutation(
    useGraphaelDefaults(),
  );

  const onClick = useCallback(() => {
    setPopperOpen(false);
    if (isAuthenticated) {
      setNotificationShown({
        variables: {
          notificationType: NotificationType.StoryDetailsActionsMenuTooltip,
        },
      });
    }
  }, [isAuthenticated, setNotificationShown]);

  return (
    <>
      {popperOpen && (
        <Tooltip
          open={popperOpen}
          arrowPlacement="bottom"
          onDismiss={onClick}
          anchorElement={anchorEl}
          message={
            <Message message={{ id: 'components.FirstTimeTooltip.content' }} />
          }
        />
      )}
    </>
  );
};

export default FirstTimeTooltip;
